import { useState } from "react";

function removeRedBookCache() {
    if(localStorage) {
        for(var key in localStorage) {
            if(typeof key === 'string' && key.startsWith('entry-')) {
                localStorage.removeItem(key);
            }
        }
    }
}

export default function DebugMenu() {

    const [showMenu, setShowMenu] = useState(false);

    // if(!showMenu) {
    //     return <button className="cursor-pointer text-xs font-bold px-0 flex justify-between" onClick={() => setShowMenu(true)}>
    //         <span><i className="zmdi zmdi-wrench text-left" /></span>
    //         Cache
    //     </button>
    // }

    return <>
        <button className="cursor-pointer text-xs font-bold px-0 flex h-full w-full" onClick={() => setShowMenu(true)}>
            <span><i className="zmdi zmdi-wrench text-left" /></span>
            Cache
        </button>
       {showMenu && <div className="">
            <div className="fixed top-0 left-0 w-screen h-screen bg-black bg-opacity-50" onClick={() => setShowMenu(false)}>
                <div className="fixed top-2 right-2 bg-whiterounded-lg">
                    <button className="rounded-full  p-2 cursor-pointer bg-[#3A194A]" onClick={() => setShowMenu(false)}><XMarkButton /></button>
                </div>
                <div className=" w-full h-full p-4 flex items-center justify-center">
                    <div className="flex flex-col gap-1">
                        <button className="px-6 py-3 text-center bg-[#3A194A] text-white rounded-t-lg" onClick={() => removeRedBookCache()}>Cache (rode schriftje) wissen</button>
                        
                    </div>
                </div>
            </div>
        </div>}
    </>
}

function XMarkButton(props) {

    return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6 text-white" {...props}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
    </svg>

}
